import type { NormalizedApiError } from './apiError';

export interface OtpDetails {
  remainingAttempts?: number;
  lockedUntil?: number;
  retryAfterSeconds?: number;
  registrationToken?: string;
  token?: string;
}

export const extractOtpDetails = (normalized: NormalizedApiError | null): OtpDetails => {
  if (!normalized) return {};

  if (normalized.format === 'new' && normalized.details) {
    const d = normalized.details as Record<string, unknown>;
    return {
      remainingAttempts: typeof d.remainingAttempts === 'number' ? d.remainingAttempts : undefined,
      lockedUntil: typeof d.lockedUntil === 'number' ? d.lockedUntil : undefined,
      retryAfterSeconds: typeof d.retryAfterSeconds === 'number' ? d.retryAfterSeconds : undefined,
      registrationToken: typeof d.registrationToken === 'string' ? d.registrationToken : undefined,
      token: typeof d.token === 'string' ? d.token : undefined,
    };
  }

  return {};
};
